"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _piwik = _interopRequireDefault(require("../vendor/piwik"));

var _web = require("@hk01-digital/react-native-webview-events/cjs/web");

/* global window */
function init(_ref, sendPageView) {
  var _isSupportedApp;

  var trackingUrl = _ref.trackingUrl,
      siteId = _ref.siteId,
      userId = _ref.userId,
      _ref$isSPA = _ref.isSPA,
      isSPA = _ref$isSPA === void 0 ? true : _ref$isSPA;
  if (!trackingUrl) throw new Error("Piwik tracking url is missing");
  if (!siteId) throw new Error("Piwik site id is missing");
  if (!userId) throw new Error("Piwik user id is missing");
  (0, _piwik.default)();
  var client = window.Piwik;
  var tracker = client.getTracker(trackingUrl, siteId);
  tracker.setUserId(userId);

  if ((0, _web.isSupportedApp)((_isSupportedApp = {}, (0, _defineProperty2.default)(_isSupportedApp, _web.APP_ENUMS["01ICON"], ">=1.0.0"), (0, _defineProperty2.default)(_isSupportedApp, _web.APP_ENUMS["HK01"], ">=3.19.0"), (0, _defineProperty2.default)(_isSupportedApp, _web.APP_ENUMS["LETZGOAL"], ">=1.4.0"), _isSupportedApp))) {
    tracker.setCustomVariable(1, "webview", true);
  }

  var setCustomDimension = function setCustomDimension() {
    var customDimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.entries(customDimensions).map(function (row) {
      var _row = (0, _slicedToArray2.default)(row, 2),
          key = _row[0],
          value = _row[1];

      tracker.setCustomDimension(key, value);

      if (key === 7) {
        // for piwik, dimension 7 and 9 are both member ID
        tracker.setCustomDimension(9, value);
      }
    });
  };

  function pageView(referrerUrl, currentUrl) {
    var customDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // track page view of Single page applications
    // https://matomo.org/blog/2017/02/how-to-track-single-page-websites-using-piwik-analytics/
    if (isSPA) {
      if (referrerUrl) {
        tracker.setReferrerUrl(referrerUrl);
      }

      if (currentUrl) {
        tracker.setCustomUrl(currentUrl);
      }

      tracker.setDocumentTitle(window.document.title);
      tracker.setGenerationTimeMs(0);
    }

    var params = {};
    Object.entries(customDimensions).map(function (row) {
      var _row2 = (0, _slicedToArray2.default)(row, 2),
          key = _row2[0],
          value = _row2[1];

      params["dimension".concat(key)] = value;

      if (row[0] === 7) {
        // for piwik, dimension 7 and 9 are both member ID
        params["dimension9"] = value;
      }
    });
    tracker.trackPageView(undefined, params);
    tracker.enableLinkTracking(true);
  }

  function fire() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        category = _ref2.category,
        action = _ref2.action,
        label = _ref2.label,
        value = _ref2.value,
        _ref2$customDimension = _ref2.customDimensions,
        customDimensions = _ref2$customDimension === void 0 ? {} : _ref2$customDimension;

    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var referrerUrl = option.referrerUrl,
        currentUrl = option.currentUrl;

    if (isSPA) {
      if (referrerUrl) {
        tracker.setReferrerUrl(referrerUrl);
      }

      if (currentUrl) {
        tracker.setCustomUrl(currentUrl);
      }

      tracker.setDocumentTitle(window.document.title);
      tracker.setGenerationTimeMs(0);
    }

    var params = {};
    Object.entries(customDimensions).map(function (row) {
      var _row3 = (0, _slicedToArray2.default)(row, 2),
          key = _row3[0],
          value = _row3[1];

      params["dimension".concat(key)] = value;

      if (row[0] === 7) {
        // for piwik, dimension 7 and 9 are both member ID
        params["dimension9"] = value;
      }
    });
    tracker.trackEvent(category, action, label, value, params);
  } // send page view immediately


  if (sendPageView) {
    pageView(); // calling pageView() on SSR doesn't need to provide old and current url
  }

  return {
    setCustomDimension: setCustomDimension,
    pageView: pageView,
    fire: fire,
    tracker: tracker
  };
}

;